import React from "react"
import css from "../css"
import {slide, arrows} from "./slider-service"

if (css) require('./slider.scss')

const noselect = {userSelect: 'none'}
const disabled = {opacity: '0.5', pointerEvents: 'none' , userSelect: 'none'}
const hide = {display: 'none'}      
const align = (a='center') => ({
    left: 'flex-start',
    right: 'flex-end',
    }[a] || a)

export const Slider = React.createClass({
    getInitialState() {
        return {
            leftMax  : true,
            rightMax : false,
            position : 0,
        } 
    },
    componentDidMount() {
        if (this.props.attach)
            this.props.attach[this.props.name] = this
        this.arrows()
        window.addEventListener('resize', () => {
            this.slide(null)
            this.arrows()
        });
    },
    componentWillUnmount() {
        if (this.props.attach)
            this.props.attach[this.props.name] = undefined
    },  
    width(ref) {
        return this.refs[ref].clientWidth
    },

    reset() {
        this.setState(this.getInitialState())
        this.arrows()
    },

    slide(dir) {
        if (this.refs.children && this.refs.track)
            this.setState(slide(this, dir))
    },

    onRouteChange() {
        this.arrows()
    },

    arrows() {
        if (this.refs.children && this.refs.track) {
            this.setState(arrows(this))
            this.setState(slide(this))
        }
    },

    render() {
        const arrowCss = dir => this.state.arrows ? (this.state[dir+'Max'] ? disabled : noselect) : hide 
        return (
            <div className="slider" style={noselect}>
                <img className="arrow"
                    src="/static/images/global/chevrons/chevron-left-grey1@2x.png"
                    style={arrowCss('left')}
                    onClick={e => this.slide('left')}
                    />
                <div className="track" ref="track" style={{
                    "--height":this.props.height+'px',
                    }}>
                    <div className="children" ref="children" style={{
                        transform:`translateX(${this.state.position}px)`,
                        justifyContent: align(this.props.align),
                        }}>
                        {this.props.children}
                    </div>
                </div>
                <img className="arrow"
                    src="/static/images/global/chevrons/chevron-right-grey1@2x.png"
                    style={arrowCss('right')}
                    onClick={e => this.slide('right')}
                    />
            </div>
        )
    }
})



// WEBPACK FOOTER //
// ./src/components/slider.jsx